'use client';

import { memo, Suspense } from 'react';
import { Toaster } from 'react-hot-toast';

import { CartProvider } from '@contexts/cart';
import { CheckoutProvider } from '@contexts/checkout';
import { HeaderProvider } from '@contexts/headers';
import { RecurrenceProvider } from '@contexts/recurrence';
import { TranslateProvider } from '@contexts/TranslateContext';
import { ZipcodeProvider } from '@contexts/zipcode';
import { Provider as JotaiProvider } from 'jotai';

import { GTMDataLayerProvider } from '@hooks';

import { LACHeader } from '@components/common/LACHeader';

import { AppWrapper } from './common/AppWrapper';

function AppProvider({ children }: React.PropsWithChildren) {
  return (
    <JotaiProvider>
      <HeaderProvider>
        <GTMDataLayerProvider>
          <ZipcodeProvider>
            <CartProvider>
              <RecurrenceProvider>
                <CheckoutProvider>
                  <TranslateProvider>
                    <AppWrapper>
                      <Suspense>
                        <LACHeader />
                      </Suspense>

                      {children}
                    </AppWrapper>
                    <Toaster containerClassName="mt-10" />
                  </TranslateProvider>
                </CheckoutProvider>
              </RecurrenceProvider>
            </CartProvider>
          </ZipcodeProvider>
        </GTMDataLayerProvider>
      </HeaderProvider>
    </JotaiProvider>
  );
}

const component = memo(AppProvider);
component.displayName = 'AppProvider';

export default component;
